import axios from 'axios';
import * as utils from '../../../utils/Utils';
import { getApiRoot } from '../../../constants/ParamountReactConstants';

const CancelToken = axios.CancelToken;

export function fetchItemDeliveryStatuses(itemId: number) {
  return {
    type: 'FETCH_ITEM_DELIVERY_STATUSES',
    payload: axios.get(`${getApiRoot()}/items/${itemId}/delivery_statuses`),
  };
}

let fetchChannelDeliveryLogsOverviewCancelToken: any;

export function fetchChannelDeliveryLogsOverview({
  itemId,
  channelId,
  receiverId,
}: {
  itemId: number;
  channelId: number | null;
  receiverId: number | null;
}) {
  if (fetchChannelDeliveryLogsOverviewCancelToken) fetchChannelDeliveryLogsOverviewCancelToken();

  const params = utils.createURL([
    { name: 'item_id', values: itemId },
    { name: 'channel_id', values: channelId },
    { name: 'receiver_id', values: receiverId },
  ]);

  return {
    type: 'FETCH_CHANNEL_DELIVERY_LOGS_OVERVIEW',
    payload: axios.get(`${getApiRoot()}/channels/delivery_logs/overview${params}`, {
      cancelToken: new CancelToken(c => {
        fetchChannelDeliveryLogsOverviewCancelToken = c;
      }),
    }),
  };
}
